import copy from "clipboard-copy";
import { useState } from "react";
import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/cjs/styles/hljs";
import copyIcon from "../assets/copy.svg";
import successIcon from "../assets/success.svg";

const CodeHighlight = ({ code }) => {
  const [copied, setCopied] = useState();

  return (
    <div className={"code-highlight"}>
      <div className={"code-highlight__with-copy"}>
        <div
          className={"code-highlight__copy-button"}
          onClick={() => {
            copy(code).then(() => {
              setCopied(true);

              setTimeout(() => {
                setCopied(false);
              }, 2000);
            });
          }}
        >
          {copied ? (
            <>
              <img
                src={successIcon}
                className={"code-highlight__copy-icon"}
                alt=""
              />
              Copied
            </>
          ) : (
            <>
              <img
                className={"code-highlight__copy-icon"}
                src={copyIcon}
                alt=""
              />
              Copy
            </>
          )}
        </div>

        <SyntaxHighlighter
          language="vbscript-html"
          style={atomOneDark}
          wrapLines={true}
        >
          {code}
        </SyntaxHighlighter>
      </div>
    </div>
  );
};

export { CodeHighlight };
